import { useEffect, useState } from 'react';
import customAxios from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';

const useAllocatedToOptions = () => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    const fetchAllocatedUsers = async () => {
      try {
        const res = await customAxios.get('/User/GetAllUsers', {
          headers: authHeader(),
        });

        if (res.status === 200 && Array.isArray(res.data)) {
          const emails = res.data
            .filter(user => user?.email) // just to be safe
            .map(user => user.email);
          setOptions(emails);
        }
      } catch (err) {
        console.error('Error fetching allocated users:', err);
      }
    };

    fetchAllocatedUsers();
  }, []);

  return { options };
};

export default useAllocatedToOptions;
